// PayPal Configuration
export const PAYPAL_CONFIG = {
  'client-id': 'AbbjN_u6dzEpGp0vxMgq9xmBUQgferae6tpZGVOYo9EdWBtpFDnnSG_BZdo7U2go-T6Y7SlE-4iqbXVh',
  currency: 'USD',
  intent: 'capture',
  components: ['buttons'],
  // For production, use 'production'
  environment: 'production'
};

// PayPal Button Styles
export const PAYPAL_BUTTON_STYLES = {
  layout: 'vertical',
  color: 'gold',
  shape: 'rect',
  label: 'pay',
  height: 50
}; 